import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  useTheme,
  NumberField,
} from "react-admin";
import inventoryCardFilterList from "../../components/inventoryCards/filter/inventoryCardFilterList";
import InventoryCardExpandList from "../../components/inventoryCards/expand/InventoryCardExpandList";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import InventoryCardFooterList from "../../components/inventoryCards/footer/InventoryCardFooterList";
import ManualReportList from "../../components/reports/ManualReportList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();
const inventoryCardDefaultFilters = {
  start_date: firstDate,
  end_date: lastDate,
};

const InventoryCardList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters(inventoryCardDefaultFilters);
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        storeKey={false} // Disabling Parameters Persistence
        title="mine.list_title.inventory_card"
        empty={false}
        // aside={<InventoryCardAsideList />}
        actions={<DownloadAction />}
        filters={inventoryCardFilterList(permissions)}
        filterDefaultValues={filterDefaultValues}
        queryOptions={{ meta: { sort: ["products.code ASC"] } }} // overide default sort
        sx={{
          flexDirection: "column",
        }}
      >
        <DatagridConfigurable
          body={
            <MyDatagridBody
              footer={
                <InventoryCardFooterList
                  canSeeCompanyColumn={canSeeCompanyColumn}
                />
              }
            />
          }
          bulkActionButtons={false}
          // rowClick={rowClickHandler}
          expand={<InventoryCardExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField label="mine.label.depo" source="company.alias" />
          ) : null}
          <TextField source="code" label="mine.label.product_code" />
          <NumberField source="initial" label="mine.label.initial" />
          <NumberField
            source="initial_value"
            label="mine.label.initial_value"
          />
          <NumberField source="total_in" label="mine.label.total_in" />
          <NumberField source="total_in_value" label="mine.label.value_in" />
          <NumberField source="total_out" label="mine.label.total_out" />
          <NumberField source="total_out_value" label="mine.label.value_out" />
          <NumberField source="other" label="mine.label.other" />
          <NumberField source="other_value" label="mine.label.other_value" />
          <NumberField source="final" label="mine.label.final" />
          <NumberField source="hpp" label="mine.label.cogs" />
          <NumberField source="final_value" label="mine.label.final_value" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, filterDefaultValues, canSeeCompanyColumn]
  );

  return list;
};

export default InventoryCardList;
